import { Action } from '@ngrx/store';
import {
  ClassQueryParameters,
  DirectMessageTemplateQueryParameters,
  EmployeeQueryParameters,
  LocationQueryParameters,
  MessageTypeQueryParameters,
  ProvinceStateQueryParameters,
  TechnicianGroupQueryParameters,
  DeclinedReasonQueryParameters,
  ServiceCodeQueryParameters,
  TransportOptionQueryParameters,
  WarrantySubmissionTypeQueryParameters,
  ColourQueryParameters,
  SubTypeQueryParameters,
  VehicleInspectionWearPatternQueryParameters,
  VehicleMakeQueryParameters,
} from '@quorum/models/xs-query';
import {
  Class,
  DirectMessageTemplate,
  Employee,
  Location,
  MessageType,
  ProvinceState,
  TechnicianGroup,
  ServiceCode,
  TransportOption,
  WarrantySubmissionType,
  VehicleColour as Colour,
  SubType,
  VehicleInspectionWearPattern,
  VehicleMake,
} from '@quorum/models/xs-resource';

export enum ServiceLaneDropdownsActionTypes {
  GetAssociateClassesFromServer = '[ServiceLaneDropdowns] Associate Classes From Server',
  GetAssociateClassesFromServerError = '[ServiceLaneDropdowns] Associate Classes From Server Error',
  GetAssociateClassesFromServerSuccess = '[ServiceLaneDropdowns] Associate Classes From Server Success',
  GetLocationsFromServer = '[ServiceLaneDropdowns] Associate Locations From Server',
  GetLocationsFromServerError = '[ServiceLaneDropdowns] Associate Locations From Server Error',
  GetLocationsFromServerSuccess = '[ServiceLaneDropdowns] Associate Locations From Server Success',
  GetMessageTypesFromServer = '[ServiceLaneDropdowns] Associate Message Types From Server',
  GetMessageTypesFromServerError = '[ServiceLaneDropdowns] Associate Message Types From Server Error',
  GetMessageTypesFromServerSuccess = '[ServiceLaneDropdowns] Associate Message Types From Server Success',
  GetProvinceStatesFromServer = '[ServiceLaneDropdowns] Province States From Server',
  GetProvinceStatesFromServerError = '[ServiceLaneDropdowns] Province States From Server Error',
  GetProvinceStatesFromServerSuccess = '[ServiceLaneDropdowns] Province States From Server Success',
  GetEmployeesFromServer = '[ServiceLaneDropdowns] Employees From Server',
  GetEmployeesFromServerError = '[ServiceLaneDropdowns] Employees From Server Error',
  GetEmployeesFromServerSuccess = '[ServiceLaneDropdowns] Employees From Server Success',
  GetServiceCodesFromServer = '[ServiceLaneDropdowns] Service Codes From Server',
  GetServiceCodesFromServerError = '[ServiceLaneDropdowns] Service Codes From Server Error',
  GetServiceCodesFromServerSuccess = '[ServiceLaneDropdowns] Service Codes From Server Success',
  GetTechnicianGroupsFromServer = '[ServiceLaneDropdowns] Technician Groups From Server',
  GetTechnicianGroupsFromServerError = '[ServiceLaneDropdowns] Technician Groups From Server Error',
  GetTechnicianGroupsFromServerSuccess = '[ServiceLaneDropdowns] Technician Groups From Server Success',
  GetVehicleColoursFromServer = '[ServiceLaneDropdowns] Vehicle Colours From Server',
  GetVehicleColoursFromServerError = '[ServiceLaneDropdowns] Vehicle Colours From Server Error',
  GetVehicleColoursFromServerSuccess = '[ServiceLaneDropdowns] Vehicle Colours From Server Success',
  GetVehicleSubTypesFromServer = '[ServiceLaneDropdowns] Vehicle SubTypes From Server',
  GetVehicleSubTypesFromServerError = '[ServiceLaneDropdowns] Vehicle SubTypes From Server Error',
  GetVehicleSubTypesFromServerSuccess = '[ServiceLaneDropdowns] Vehicle SubTypes From Server Success',
  GetVehicleMakesFromServer = '[ServiceLaneDropdowns] Vehicle Makes From Server',
  GetVehicleMakesFromServerError = '[ServiceLaneDropdowns] Vehicle Makes From Server Error',
  GetVehicleMakesFromServerSuccess = '[ServiceLaneDropdowns] Vehicle Makes From Server Success',
  GetWarrantySubmissionTypesFromServer = '[ServiceLaneDropdowns] Submission Types From Server',
  GetWarrantySubmissionTypesFromServerError = '[ServiceLaneDropdowns] Submission Types From Server Error',
  GetWarrantySubmissionTypesFromServerSuccess = '[ServiceLaneDropdowns] Submission Types From Server Success',
  GetDirectMessageTemplatesFromServer = '[ServiceLaneDropdowns] Direct Message Templates From Server',
  GetDirectMessageTemplatesFromServerError = '[ServiceLaneDropdowns] Direct Message Templates From Server Error',
  GetDirectMessageTemplatesFromServerSuccess = '[ServiceLaneDropdowns] Direct Message Templates From Server Success',
  GetTransportOptionsFromServer = '[ServiceLaneDropdowns] Transport Options From Server',
  GetTransportOptionsFromServerError = '[ServiceLaneDropdowns] Transport Options From Server Error',
  GetTransportOptionsFromServerSuccess = '[ServiceLaneDropdowns] Transport Options From Server Success',
  GetDeclinedReasonsFromServer = '[ServiceLaneDropdowns] Declined Reasons From Server',
  GetDeclinedReasonsFromServerError = '[ServiceLaneDropdowns] Declined Reasons From Server Error',
  GetDeclinedReasonsFromServerSuccess = '[ServiceLaneDropdowns] Declined Reasons From Server Success',
  GetVehicleInspectionWearPatternsFromServer = '[ServiceLaneDropdowns] Vehicle Inspection Wear Patterns From Server',
  // eslint-disable-next-line max-len
  GetVehicleInspectionWearPatternsFromServerError = '[ServiceLaneDropdowns] Vehicle Inspection Wear Patterns From Server Error',
  // eslint-disable-next-line max-len
  GetVehicleInspectionWearPatternsFromServerSuccess = '[ServiceLaneDropdowns] Vehicle Inspection Wear Patterns From Server Success',
}

//#region message-types
export class GetLocationsFromServer implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetLocationsFromServer;
  constructor(public payload: LocationQueryParameters) {}
}

export class GetLocationsFromServerError implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetLocationsFromServerError;
  constructor(public payload: any) {}
}

export class GetLocationsFromServerSuccess implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetLocationsFromServerSuccess;
  constructor(public payload: Location[]) {}
}
//#endregion

//#region associate-classes
export class GetAssociateClassesFromServer implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetAssociateClassesFromServer;
  constructor(public payload: ClassQueryParameters) {}
}

export class GetAssociateClassesFromServerError implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetAssociateClassesFromServerError;
  constructor(public payload: any) {}
}

export class GetAssociateClassesFromServerSuccess implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetAssociateClassesFromServerSuccess;
  constructor(public payload: Class[]) {}
}
//#endregion

//#region message-types
export class GetMessageTypesFromServer implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetMessageTypesFromServer;
  constructor(public payload: MessageTypeQueryParameters) {}
}

export class GetMessageTypesFromServerError implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetMessageTypesFromServerError;
  constructor(public payload: any) {}
}

export class GetMessageTypesFromServerSuccess implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetMessageTypesFromServerSuccess;
  constructor(public payload: MessageType[]) {}
}
//#endregion

//#region province/states
export class GetProvinceStatesFromServer implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetProvinceStatesFromServer;
  constructor(public payload: ProvinceStateQueryParameters) {}
}

export class GetProvinceStatesFromServerError implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetProvinceStatesFromServerError;
  constructor(public payload: any) {}
}

export class GetProvinceStatesFromServerSuccess implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetProvinceStatesFromServerSuccess;
  constructor(public payload: ProvinceState[]) {}
}
//#endregion

//#region Employees
export class GetEmployeesFromServer implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetEmployeesFromServer;
  constructor(public payload: EmployeeQueryParameters) {}
}

export class GetEmployeesFromServerError implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetEmployeesFromServerError;
  constructor(public payload: any) {}
}

export class GetEmployeesFromServerSuccess implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetEmployeesFromServerSuccess;
  constructor(public payload: Employee[]) {}
}
//#endregion

//#region service codes
export class GetServiceCodesFromServer implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetServiceCodesFromServer;
  constructor(public payload: ServiceCodeQueryParameters) {}
}

export class GetServiceCodesFromServerError implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetServiceCodesFromServerError;
  constructor(public payload: any) {}
}

export class GetServiceCodesFromServerSuccess implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetServiceCodesFromServerSuccess;
  constructor(public payload: ServiceCode[]) {}
}
//#endregion

//#region technician groups
export class GetTechnicianGroupsFromServer implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetTechnicianGroupsFromServer;
  constructor(public payload: TechnicianGroupQueryParameters) {}
}

export class GetTechnicianGroupsFromServerError implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetTechnicianGroupsFromServerError;
  constructor(public payload: any) {}
}

export class GetTechnicianGroupsFromServerSuccess implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetTechnicianGroupsFromServerSuccess;
  constructor(public payload: TechnicianGroup[]) {}
}
//#endregion

//#region warranty submission types
export class GetWarrantySubmissionTypesFromServer implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetWarrantySubmissionTypesFromServer;
  constructor(public payload: WarrantySubmissionTypeQueryParameters) {}
}

export class GetWarrantySubmissionTypesFromServerError implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetWarrantySubmissionTypesFromServerError;
  constructor(public payload: any) {}
}

export class GetWarrantySubmissionTypesFromServerSuccess implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetWarrantySubmissionTypesFromServerSuccess;
  constructor(public payload: WarrantySubmissionType[]) {}
}
//#endregion

//#region vehicle colours
export class GetVehicleColoursFromServer implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetVehicleColoursFromServer;
  constructor(public payload: ColourQueryParameters) {}
}

export class GetVehicleColoursFromServerError implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetVehicleColoursFromServerError;
  constructor(public payload: any) {}
}

export class GetVehicleColoursFromServerSuccess implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetVehicleColoursFromServerSuccess;
  constructor(public payload: Colour[]) {}
}
//#endregion

//#region vehicle colours
export class GetVehicleSubTypesFromServer implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetVehicleSubTypesFromServer;
  constructor(public payload: SubTypeQueryParameters) {}
}

export class GetVehicleSubTypesFromServerError implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetVehicleSubTypesFromServerError;
  constructor(public payload: any) {}
}

export class GetVehicleSubTypesFromServerSuccess implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetVehicleSubTypesFromServerSuccess;
  constructor(public payload: SubType[]) {}
}
//#endregion

//#region vehicle makes
export class GetVehicleMakesFromServer implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetVehicleMakesFromServer;
  constructor(public payload: VehicleMakeQueryParameters) {}
}

export class GetVehicleMakesFromServerError implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetVehicleMakesFromServerError;
  constructor(public payload: any) {}
}

export class GetVehicleMakesFromServerSuccess implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetVehicleMakesFromServerSuccess;
  constructor(public payload: VehicleMake[]) {}
}
//#endregion

//#region message-types
export class GetDirectMessageTemplatesFromServer implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetDirectMessageTemplatesFromServer;
  constructor(public payload: DirectMessageTemplateQueryParameters) {}
}

export class GetDirectMessageTemplatesFromServerError implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetDirectMessageTemplatesFromServerError;
  constructor(public payload: any) {}
}

export class GetDirectMessageTemplatesFromServerSuccess implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetDirectMessageTemplatesFromServerSuccess;
  constructor(public payload: DirectMessageTemplate[]) {}
}
//#endregion

//#region message-types
export class GetTransportOptionsFromServer implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetTransportOptionsFromServer;
  constructor(public payload: TransportOptionQueryParameters) {}
}

export class GetTransportOptionsFromServerError implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetTransportOptionsFromServerError;
  constructor(public payload: any) {}
}

export class GetTransportOptionsFromServerSuccess implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetTransportOptionsFromServerSuccess;
  constructor(public payload: TransportOption[]) {}
}
//#endregion

//#region declined-reasons
export class GetDeclinedReasonsFromServer implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetDeclinedReasonsFromServer;
  constructor(public payload: DeclinedReasonQueryParameters) {}
}

export class GetDeclinedReasonsFromServerError implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetDeclinedReasonsFromServerError;
  constructor(public payload: any) {}
}

export class GetDeclinedReasonsFromServerSuccess implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetDeclinedReasonsFromServerSuccess;
  constructor(public payload: any[]) {}
}
//#endregion

//#region vehicle inspection wear patterns
export class GetVehicleInspectionWearPatternsFromServer implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetVehicleInspectionWearPatternsFromServer;
  constructor(public payload: VehicleInspectionWearPatternQueryParameters) {}
}

export class GetVehicleInspectionWearPatternsFromServerError implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetVehicleInspectionWearPatternsFromServerError;
  constructor(public payload: any) {}
}

export class GetVehicleInspectionWearPatternsFromServerSuccess implements Action {
  readonly type = ServiceLaneDropdownsActionTypes.GetVehicleInspectionWearPatternsFromServerSuccess;
  constructor(public payload: VehicleInspectionWearPattern[]) {}
}
//#endregion

export type ServiceLaneDropdownsAction =
  | GetAssociateClassesFromServer
  | GetAssociateClassesFromServerError
  | GetAssociateClassesFromServerSuccess
  | GetLocationsFromServer
  | GetLocationsFromServerError
  | GetLocationsFromServerSuccess
  | GetMessageTypesFromServer
  | GetMessageTypesFromServerError
  | GetMessageTypesFromServerSuccess
  | GetProvinceStatesFromServer
  | GetProvinceStatesFromServerError
  | GetProvinceStatesFromServerSuccess
  | GetEmployeesFromServer
  | GetEmployeesFromServerError
  | GetEmployeesFromServerSuccess
  | GetServiceCodesFromServer
  | GetServiceCodesFromServerError
  | GetServiceCodesFromServerSuccess
  | GetTechnicianGroupsFromServer
  | GetTechnicianGroupsFromServerError
  | GetTechnicianGroupsFromServerSuccess
  | GetVehicleColoursFromServer
  | GetVehicleColoursFromServerError
  | GetVehicleColoursFromServerSuccess
  | GetVehicleSubTypesFromServer
  | GetVehicleSubTypesFromServerError
  | GetVehicleSubTypesFromServerSuccess
  | GetVehicleMakesFromServer
  | GetVehicleMakesFromServerError
  | GetVehicleMakesFromServerSuccess
  | GetWarrantySubmissionTypesFromServer
  | GetWarrantySubmissionTypesFromServerError
  | GetWarrantySubmissionTypesFromServerSuccess
  | GetDirectMessageTemplatesFromServer
  | GetDirectMessageTemplatesFromServerError
  | GetDirectMessageTemplatesFromServerSuccess
  | GetTransportOptionsFromServer
  | GetTransportOptionsFromServerError
  | GetTransportOptionsFromServerSuccess
  | GetDeclinedReasonsFromServer
  | GetDeclinedReasonsFromServerError
  | GetDeclinedReasonsFromServerSuccess
  | GetVehicleInspectionWearPatternsFromServer
  | GetVehicleInspectionWearPatternsFromServerError
  | GetVehicleInspectionWearPatternsFromServerSuccess;

export const fromServiceLaneDropdownsActions = {
  GetAssociateClassesFromServer,
  GetAssociateClassesFromServerError,
  GetAssociateClassesFromServerSuccess,
  GetLocationsFromServer,
  GetLocationsFromServerError,
  GetLocationsFromServerSuccess,
  GetMessageTypesFromServer,
  GetMessageTypesFromServerError,
  GetMessageTypesFromServerSuccess,
  GetProvinceStatesFromServer,
  GetProvinceStatesFromServerError,
  GetProvinceStatesFromServerSuccess,
  GetEmployeesFromServer,
  GetEmployeesFromServerError,
  GetEmployeesFromServerSuccess,
  GetServiceCodesFromServer,
  GetServiceCodesFromServerError,
  GetServiceCodesFromServerSuccess,
  GetTechnicianGroupsFromServer,
  GetTechnicianGroupsFromServerError,
  GetTechnicianGroupsFromServerSuccess,
  GetVehicleColoursFromServer,
  GetVehicleColoursFromServerError,
  GetVehicleColoursFromServerSuccess,
  GetVehicleSubTypesFromServer,
  GetVehicleSubTypesFromServerError,
  GetVehicleSubTypesFromServerSuccess,
  GetVehicleMakesFromServer,
  GetVehicleMakesFromServerError,
  GetVehicleMakesFromServerSuccess,
  GetWarrantySubmissionTypesFromServer,
  GetWarrantySubmissionTypesFromServerError,
  GetWarrantySubmissionTypesFromServerSuccess,
  GetDirectMessageTemplatesFromServer,
  GetDirectMessageTemplatesFromServerError,
  GetDirectMessageTemplatesFromServerSuccess,
  GetTransportOptionsFromServer,
  GetTransportOptionsFromServerError,
  GetTransportOptionsFromServerSuccess,
  GetDeclinedReasonsFromServer,
  GetDeclinedReasonsFromServerError,
  GetDeclinedReasonsFromServerSuccess,
  GetVehicleInspectionWearPatternsFromServer,
  GetVehicleInspectionWearPatternsFromServerError,
  GetVehicleInspectionWearPatternsFromServerSuccess,
};
